var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgSwap(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 10.75H3.46875L5.78125 8.28125C6.0625 7.96875 6.0625 7.5 5.75 7.21875C5.4375 6.9375 4.96875 6.9375 4.6875 7.25L1.1875 11C0.90625 11.2812 0.90625 11.75 1.1875 12.0312L4.6875 15.7812C4.84375 15.9375 5.03125 16 5.25 16C5.40625 16 5.59375 15.9375 5.75 15.8125C6.0625 15.5312 6.0625 15.0625 5.78125 14.75L3.46875 12.25H16.25C16.6562 12.25 17 11.9375 17 11.5C17 11.0938 16.6562 10.75 16.25 10.75ZM1.75 5.25H14.5L12.1875 7.75C11.9062 8.0625 11.9062 8.53125 12.2188 8.8125C12.5312 9.09375 13 9.09375 13.2812 8.78125L16.7812 5.03125C17.0625 4.75 17.0625 4.28125 16.7812 4L13.2812 0.25C13.125 0.09375 12.9375 0 12.75 0C12.5625 0 12.375 0.09375 12.2188 0.21875C11.9062 0.5 11.9062 0.96875 12.1875 1.28125L14.5 3.75H1.75C1.3125 3.75 1 4.09375 1 4.5C1 4.9375 1.3125 5.25 1.75 5.25Z",
    fill: "#6A747F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSwap);
export default __webpack_public_path__ + "static/media/img_swap.0e48ac9e2359fc3d99bc7d9e95567c01.svg";
export { ForwardRef as ReactComponent };